import { jsx as _jsx } from "react/jsx-runtime";
const Ellipses = () => {
  return /*#__PURE__*/_jsx("span", {
    className: "ds-c-pagination__overflow",
    children: "\u2026"
  });
};
export default Ellipses;